/**
 * @generated SignedSource<<e3bd08eb4faa1cc015d0746b3fa6fd43>>
 * @relayHash 3959015bcafbd9a73dd0c192671cf8b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bab7c1dad02a329512e40ea7df1c6e49083e199bbc28b2d6f75daf5c9ead996f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AggGoalTabContentQuery$variables = {
  connectedUpdatesEnabled: boolean;
  containerId: string;
  goalKey: string;
  includeDraftUpdate: boolean;
  isDecisionsTab: boolean;
  isJiraAlignTab: boolean;
  isJiraTab: boolean;
  isLearningsTab: boolean;
  isProjectsTab: boolean;
  isRisksTab: boolean;
  isUpdatesTab: boolean;
  queryContext?: string | null;
};
export type AggGoalTabContentQuery$data = {
  readonly goals_byKey: {
    readonly " $fragmentSpreads": FragmentRefs<"AggGoalUpdatesTabContent" | "GoalContentAbout" | "GoalContentDecisions" | "GoalContentJira" | "GoalContentJiraAlign" | "GoalContentLearnings" | "GoalContentProjects" | "GoalContentRisks">;
  } | null;
};
export type AggGoalTabContentQuery = {
  response: AggGoalTabContentQuery$data;
  variables: AggGoalTabContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connectedUpdatesEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDraftUpdate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDecisionsTab"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraAlignTab"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraTab"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLearningsTab"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectsTab"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRisksTab"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isUpdatesTab"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v12 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "goalKey",
    "variableName": "goalKey"
  }
],
v13 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = {
  "kind": "ScalarField",
  "name": "description"
},
v17 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v18 = {
  "kind": "ScalarField",
  "name": "canManagePeriodicMetricTargets"
},
v19 = {
  "kind": "ScalarField",
  "name": "canCreateGoal"
},
v20 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v21 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v22 = {
  "kind": "ScalarField",
  "name": "value"
},
v23 = [
  (v22/*: any*/)
],
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v25 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v24/*: any*/)
  ]
},
v26 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v24/*: any*/)
  ]
},
v27 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v28 = {
  "kind": "ScalarField",
  "name": "archived"
},
v29 = {
  "kind": "ScalarField",
  "name": "key"
},
v30 = {
  "kind": "ScalarField",
  "name": "name"
},
v31 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v32 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v33 = {
  "kind": "ScalarField",
  "name": "start"
},
v34 = {
  "kind": "ScalarField",
  "name": "end"
},
v35 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/)
  ]
},
v36 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "date",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v35/*: any*/)
  ]
},
v37 = [
  (v22/*: any*/),
  (v15/*: any*/)
],
v38 = {
  "kind": "ScalarField",
  "name": "variance"
},
v39 = {
  "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v37/*: any*/)
    },
    (v38/*: any*/)
  ]
},
v40 = {
  "kind": "ScalarField",
  "name": "type"
},
v41 = {
  "kind": "ScalarField",
  "name": "subType"
},
v42 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v43 = [
  (v42/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_DESC"
    ]
  }
],
v44 = {
  "kind": "ScalarField",
  "name": "time"
},
v45 = {
  "kind": "ScalarField",
  "name": "picture"
},
v46 = [
  (v21/*: any*/),
  (v30/*: any*/),
  (v45/*: any*/),
  (v15/*: any*/)
],
v47 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v46/*: any*/)
},
v48 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v49 = [
  (v15/*: any*/)
],
v50 = {
  "kind": "ScalarField",
  "name": "score"
},
v51 = [
  (v22/*: any*/),
  (v50/*: any*/)
],
v52 = {
  "kind": "LinkedField",
  "name": "origin",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "TownsquareGoalUpdate",
          "kind": "LinkedField",
          "name": "goalUpdate",
          "plural": false,
          "selections": [
            (v48/*: any*/),
            {
              "concreteType": "TownsquareGoal",
              "kind": "LinkedField",
              "name": "goal",
              "plural": false,
              "selections": (v49/*: any*/)
            },
            {
              "concreteType": "TownsquareGoalState",
              "kind": "LinkedField",
              "name": "newState",
              "plural": false,
              "selections": (v51/*: any*/)
            },
            (v15/*: any*/)
          ]
        }
      ],
      "type": "TownsquareFromGoalUpdate"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v48/*: any*/)
      ],
      "type": "TownsquareFromMetricCreation"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "updateDate"
        }
      ],
      "type": "TownsquareFromMetricUpdate"
    }
  ]
},
v53 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v54 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v55 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v56 = {
  "args": (v43/*: any*/),
  "concreteType": "TownsquareMetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v15/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v22/*: any*/),
            (v44/*: any*/),
            (v47/*: any*/),
            (v52/*: any*/),
            (v53/*: any*/),
            (v21/*: any*/)
          ]
        },
        (v54/*: any*/)
      ]
    },
    (v55/*: any*/),
    (v53/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
},
v57 = {
  "args": (v43/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v58 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v59 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v37/*: any*/)
},
v60 = [
  (v44/*: any*/),
  (v15/*: any*/)
],
v61 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v34/*: any*/)
  ]
},
v62 = [
  (v61/*: any*/)
],
v63 = {
  "args": (v43/*: any*/),
  "concreteType": "TownsquareMetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v60/*: any*/)
        },
        {
          "concreteType": "TownsquareMetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "date",
              "plural": false,
              "selections": (v62/*: any*/)
            },
            (v22/*: any*/)
          ]
        },
        (v38/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_DESC\"])"
},
v64 = {
  "kind": "ScalarField",
  "name": "url"
},
v65 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v51/*: any*/)
},
v66 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v67 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareTargetDateRange",
      "kind": "LinkedField",
      "name": "dateRange",
      "plural": false,
      "selections": [
        (v34/*: any*/),
        (v33/*: any*/)
      ]
    }
  ]
},
v68 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v69 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v70 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v71 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v72 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v15/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                (v30/*: any*/),
                (v15/*: any*/),
                (v70/*: any*/),
                (v45/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v71/*: any*/),
            (v48/*: any*/)
          ]
        }
      ]
    },
    (v53/*: any*/)
  ]
},
v73 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v74 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v75 = {
  "concreteType": "TownsquareUpdateGenerationSettings",
  "kind": "LinkedField",
  "name": "updateGenerationSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "templateKey"
    }
  ]
},
v76 = [
  {
    "kind": "ScalarField",
    "name": "count"
  }
],
v77 = {
  "concreteType": "TownsquareUserConnection",
  "kind": "LinkedField",
  "name": "watchers",
  "plural": false,
  "selections": (v76/*: any*/)
},
v78 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v79 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v78/*: any*/)
  ]
},
v80 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v81 = {
  "kind": "ScalarField",
  "name": "summary"
},
v82 = [
  (v22/*: any*/),
  (v50/*: any*/),
  {
    "concreteType": "TownsquareCompletionGoalState",
    "kind": "LinkedField",
    "name": "atCompletionState",
    "plural": false,
    "selections": (v51/*: any*/)
  }
],
v83 = [
  (v21/*: any*/),
  (v45/*: any*/),
  (v30/*: any*/),
  (v70/*: any*/),
  (v15/*: any*/)
],
v84 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v83/*: any*/)
},
v85 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v83/*: any*/)
},
v86 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v87 = {
  "kind": "ScalarField",
  "name": "source"
},
v88 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v60/*: any*/)
},
v89 = [
  (v21/*: any*/),
  (v70/*: any*/),
  (v30/*: any*/),
  (v45/*: any*/),
  (v15/*: any*/)
],
v90 = [
  {
    "kind": "ScalarField",
    "name": "label"
  },
  (v35/*: any*/)
],
v91 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v92 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v93 = {
  "kind": "ScalarField",
  "name": "canDeleteUpdates"
},
v94 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v95 = [
  {
    "concreteType": "TownsquareConnectedUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "sourceGoal",
        "plural": false,
        "selections": (v49/*: any*/)
      }
    ]
  }
],
v96 = {
  "kind": "InlineFragment",
  "selections": (v49/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v97 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v98 = [
  (v97/*: any*/),
  (v13/*: any*/)
],
v99 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v81/*: any*/),
      (v16/*: any*/),
      (v84/*: any*/),
      (v85/*: any*/),
      (v48/*: any*/),
      (v86/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v100 = {
  "concreteType": "TownsquareGoalCapabilities",
  "kind": "LinkedField",
  "name": "capabilities",
  "plural": false,
  "selections": [
    (v93/*: any*/),
    (v92/*: any*/)
  ]
},
v101 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v102 = [
  (v97/*: any*/),
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v103 = {
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v23/*: any*/)
},
v104 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v15/*: any*/),
    (v30/*: any*/),
    (v45/*: any*/),
    (v70/*: any*/)
  ]
},
v105 = [
  (v21/*: any*/),
  (v15/*: any*/)
],
v106 = {
  "concreteType": "TownsquareContributorConnection",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareContributorEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareContributor",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "userContributor",
              "plural": false,
              "selections": (v105/*: any*/)
            },
            {
              "concreteType": "TownsquareTeamContributor",
              "kind": "LinkedField",
              "name": "teamContributor",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareUserConnection",
                  "kind": "LinkedField",
                  "name": "contributingMembers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareUserEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v105/*: any*/)
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v107 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v108 = [
  (v35/*: any*/)
],
v109 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v108/*: any*/)
},
v110 = {
  "args": (v102/*: any*/),
  "filters": [
    "tql"
  ],
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AggGoalTabContentQuery",
    "selections": [
      {
        "args": (v12/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byKey",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GoalContentAbout"
          },
          {
            "condition": "isUpdatesTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "connectedUpdatesEnabled",
                    "variableName": "connectedUpdatesEnabled"
                  },
                  {
                    "kind": "Variable",
                    "name": "includeDraftUpdate",
                    "variableName": "includeDraftUpdate"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "AggGoalUpdatesTabContent"
              }
            ]
          },
          {
            "condition": "isJiraAlignTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v14/*: any*/),
                "kind": "FragmentSpread",
                "name": "GoalContentJiraAlign"
              }
            ]
          },
          {
            "condition": "isJiraTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v14/*: any*/),
                "kind": "FragmentSpread",
                "name": "GoalContentJira"
              }
            ]
          },
          {
            "condition": "isLearningsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentLearnings"
              }
            ]
          },
          {
            "condition": "isRisksTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentRisks"
              }
            ]
          },
          {
            "condition": "isDecisionsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentDecisions"
              }
            ]
          },
          {
            "condition": "isProjectsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentProjects"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggGoalTabContentQuery",
    "selections": [
      {
        "args": (v12/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byKey",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "kind": "ScalarField",
            "name": "descriptionWhy"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionMeasurement"
          },
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              (v17/*: any*/),
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/)
                ]
              },
              (v20/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              }
            ]
          },
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "kind"
              },
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v15/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/)
                ]
              },
              (v15/*: any*/),
              (v25/*: any*/)
            ]
          },
          {
            "args": (v27/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      (v15/*: any*/),
                      {
                        "concreteType": "TownsquareGoalIcon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appearance"
                          }
                        ]
                      },
                      (v30/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v36/*: any*/),
                                              (v22/*: any*/),
                                              (v39/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v15/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v40/*: any*/),
                                      (v41/*: any*/),
                                      (v30/*: any*/),
                                      (v15/*: any*/),
                                      (v56/*: any*/),
                                      (v57/*: any*/)
                                    ]
                                  },
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v63/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v29/*: any*/),
                      (v64/*: any*/),
                      (v65/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v45/*: any*/),
                          (v30/*: any*/),
                          (v15/*: any*/)
                        ]
                      },
                      (v66/*: any*/),
                      (v67/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v17/*: any*/),
                          {
                            "concreteType": "TownsquareGoalAppCapabilities",
                            "kind": "LinkedField",
                            "name": "apps",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v68/*: any*/),
                      (v69/*: any*/),
                      (v48/*: any*/)
                    ]
                  },
                  (v21/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          (v72/*: any*/),
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v73/*: any*/),
              (v15/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v15/*: any*/),
                      {
                        "concreteType": "TownsquareMetric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v30/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v28/*: any*/),
                          (v74/*: any*/),
                          (v53/*: any*/),
                          (v56/*: any*/),
                          (v57/*: any*/)
                        ]
                      },
                      (v59/*: any*/),
                      (v31/*: any*/),
                      (v58/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v36/*: any*/),
                                  (v22/*: any*/),
                                  (v39/*: any*/),
                                  (v21/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v63/*: any*/)
                    ]
                  }
                ]
              },
              (v53/*: any*/)
            ]
          },
          (v68/*: any*/),
          (v69/*: any*/),
          (v48/*: any*/),
          (v67/*: any*/),
          {
            "concreteType": "TownsquareStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": (v23/*: any*/)
          },
          (v28/*: any*/),
          {
            "concreteType": "TownsquareGoalProgress",
            "kind": "LinkedField",
            "name": "progress",
            "plural": false,
            "selections": [
              (v40/*: any*/)
            ]
          },
          {
            "condition": "isUpdatesTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                  (v50/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "latestUpdateDate"
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canEditTargetDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canEditStatus"
                  },
                  (v20/*: any*/)
                ]
              },
              (v75/*: any*/),
              (v66/*: any*/),
              {
                "concreteType": "TownsquareTargetDate",
                "kind": "LinkedField",
                "name": "targetDate",
                "plural": false,
                "selections": [
                  (v32/*: any*/)
                ]
              },
              (v77/*: any*/),
              (v79/*: any*/),
              {
                "args": (v80/*: any*/),
                "concreteType": "TownsquareGoalUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v81/*: any*/),
                          {
                            "concreteType": "TownsquareUpdateNoteConnection",
                            "kind": "LinkedField",
                            "name": "updateNotes",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNoteEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareUpdateNote",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v81/*: any*/),
                                      (v16/*: any*/),
                                      (v15/*: any*/),
                                      (v28/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v21/*: any*/),
                          (v73/*: any*/),
                          (v48/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "ari"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "missedUpdate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "updateType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasConnectedUpdates"
                          },
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": (v82/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDateConfidence"
                          },
                          {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareHighlightEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v81/*: any*/),
                                      (v16/*: any*/),
                                      (v21/*: any*/),
                                      (v15/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isTownsquareHighlight"
                                      },
                                      (v84/*: any*/),
                                      (v85/*: any*/),
                                      (v48/*: any*/),
                                      (v86/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v53/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalMetricUpdateConnection",
                            "kind": "LinkedField",
                            "name": "metricUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalMetricUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          (v30/*: any*/),
                                          (v40/*: any*/),
                                          (v41/*: any*/),
                                          (v28/*: any*/),
                                          (v87/*: any*/),
                                          (v88/*: any*/),
                                          {
                                            "args": (v43/*: any*/),
                                            "concreteType": "TownsquareMetricValueConnection",
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v15/*: any*/),
                                                      (v22/*: any*/),
                                                      (v44/*: any*/),
                                                      (v47/*: any*/),
                                                      (v52/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "newValue",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v44/*: any*/),
                                          (v15/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "oldValue",
                                        "plural": false,
                                        "selections": [
                                          (v44/*: any*/),
                                          (v15/*: any*/),
                                          (v22/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newStartValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newTargetValue"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetConnection",
                                "kind": "LinkedField",
                                "name": "metricTargets",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTarget",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetric",
                                            "kind": "LinkedField",
                                            "name": "metric",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v28/*: any*/),
                                              (v30/*: any*/),
                                              (v40/*: any*/),
                                              (v41/*: any*/),
                                              (v74/*: any*/),
                                              (v87/*: any*/),
                                              (v88/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodConnection",
                                            "kind": "LinkedField",
                                            "name": "metricTargetPeriods",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDate",
                                                        "kind": "LinkedField",
                                                        "name": "date",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareTargetDateRange",
                                                            "kind": "LinkedField",
                                                            "name": "dateRange",
                                                            "plural": false,
                                                            "selections": [
                                                              (v33/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v22/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v15/*: any*/),
                                          (v31/*: any*/),
                                          (v58/*: any*/),
                                          (v59/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v15/*: any*/),
                              (v66/*: any*/),
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 10
                                  }
                                ],
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          (v81/*: any*/),
                                          {
                                            "concreteType": "TownsquareUpdateNoteConnection",
                                            "kind": "LinkedField",
                                            "name": "updateNotes",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNoteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareUpdateNote",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v81/*: any*/),
                                                      (v16/*: any*/),
                                                      (v15/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:10)"
                              },
                              (v75/*: any*/),
                              {
                                "concreteType": "TownsquareGoalProgress",
                                "kind": "LinkedField",
                                "name": "progress",
                                "plural": false,
                                "selections": [
                                  (v78/*: any*/),
                                  (v40/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "subGoals",
                                "plural": false,
                                "selections": (v76/*: any*/)
                              },
                              {
                                "alias": "successMeasureCount",
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "successMeasures",
                                "plural": false,
                                "selections": (v76/*: any*/)
                              },
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "goalType",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v15/*: any*/)
                                    ]
                                  },
                                  (v15/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": (v62/*: any*/)
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": (v89/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "newDueDate",
                            "plural": false,
                            "selections": (v90/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "newProgress",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/),
                              (v78/*: any*/)
                            ]
                          },
                          {
                            "args": (v27/*: any*/),
                            "concreteType": "TownsquareGoalBundledUpdateConnection",
                            "kind": "LinkedField",
                            "name": "bundledUpdates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalBundledUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      (v79/*: any*/),
                                      (v15/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "bundledUpdates(first:50)"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "lastEditedBy",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v70/*: any*/),
                              (v30/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          (v71/*: any*/),
                          {
                            "args": [
                              (v42/*: any*/)
                            ],
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                            "kind": "LinkedField",
                            "name": "viewers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v21/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v15/*: any*/),
                                          (v30/*: any*/),
                                          (v70/*: any*/),
                                          (v45/*: any*/)
                                        ],
                                        "type": "AtlassianAccountUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v49/*: any*/),
                                        "type": "AppUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v49/*: any*/),
                                        "type": "CustomerUser"
                                      }
                                    ]
                                  },
                                  (v15/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "viewers(first:100)"
                          },
                          (v64/*: any*/),
                          (v72/*: any*/),
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v82/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "oldDueDate",
                            "plural": false,
                            "selections": (v90/*: any*/)
                          }
                        ]
                      },
                      (v54/*: any*/),
                      (v21/*: any*/)
                    ]
                  },
                  (v55/*: any*/),
                  (v53/*: any*/)
                ],
                "storageKey": "updates(first:20)"
              },
              {
                "args": (v80/*: any*/),
                "handle": "connection",
                "key": "UpdatesList__updates",
                "kind": "LinkedHandle",
                "name": "updates"
              },
              {
                "concreteType": "TownsquareMetricTargetConnection",
                "kind": "LinkedField",
                "name": "metricTargets",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTargetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareMetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetric",
                            "kind": "LinkedField",
                            "name": "metric",
                            "plural": false,
                            "selections": [
                              (v87/*: any*/),
                              {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "latestValue",
                                "plural": false,
                                "selections": [
                                  (v44/*: any*/),
                                  (v22/*: any*/),
                                  (v15/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareGoalUpdate",
                "kind": "LinkedField",
                "name": "latestUserUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                    "kind": "LinkedField",
                    "name": "metricUpdate",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalMetricUpdateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "newValue",
                                "plural": false,
                                "selections": (v60/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v49/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "isWatching"
              },
              (v29/*: any*/),
              (v91/*: any*/),
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canCommentOnUpdates"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canWatchGoal"
                  },
                  (v92/*: any*/),
                  (v93/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditUpdate"
              },
              {
                "kind": "ScalarField",
                "name": "updateStreak"
              },
              {
                "condition": "connectedUpdatesEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "TownsquareConnectedUpdates",
                    "kind": "LinkedField",
                    "name": "connectedUpdates",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v94/*: any*/),
                        "concreteType": "TownsquareConnectedUpdateConnection",
                        "kind": "LinkedField",
                        "name": "successMeasureUpdates",
                        "plural": false,
                        "selections": (v95/*: any*/),
                        "storageKey": "successMeasureUpdates(first:1)"
                      },
                      {
                        "args": (v94/*: any*/),
                        "concreteType": "TownsquareConnectedUpdateConnection",
                        "kind": "LinkedField",
                        "name": "subGoalUpdates",
                        "plural": false,
                        "selections": (v95/*: any*/),
                        "storageKey": "subGoalUpdates(first:1)"
                      },
                      {
                        "args": (v94/*: any*/),
                        "concreteType": "TownsquareConnectedUpdateConnection",
                        "kind": "LinkedField",
                        "name": "projectUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareConnectedUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareProject",
                                "kind": "LinkedField",
                                "name": "sourceProject",
                                "plural": false,
                                "selections": (v49/*: any*/)
                              }
                            ]
                          }
                        ],
                        "storageKey": "projectUpdates(first:1)"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeDraftUpdate",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalDraftUpdate",
                    "kind": "LinkedField",
                    "name": "latestDraftUpdate",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v66/*: any*/),
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v59/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v40/*: any*/),
                                          (v41/*: any*/),
                                          (v15/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v65/*: any*/),
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              (v61/*: any*/)
                            ]
                          },
                          (v15/*: any*/)
                        ]
                      },
                      (v81/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      (v50/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDateInputDraft",
                        "kind": "LinkedField",
                        "name": "targetDate",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "date"
                          },
                          (v32/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareMetricUpdateInputDraft",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "targetId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newValue"
                          },
                          (v44/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareUpdateNoteInputDraft",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": true,
                        "selections": [
                          (v81/*: any*/),
                          (v16/*: any*/),
                          (v73/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareUpdateHighlightInputDraft",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": true,
                        "selections": [
                          (v81/*: any*/),
                          (v16/*: any*/),
                          (v40/*: any*/)
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "provenance_extension"
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": (v46/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "modifiedDate"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isJiraAlignTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v14/*: any*/),
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                "kind": "LinkedField",
                "name": "jiraAlignItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "mercuryProjectName"
                              },
                              {
                                "kind": "LinkedField",
                                "name": "mercuryProjectStatus",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "mercuryName"
                                  },
                                  (v96/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "mercuryTargetDateEnd"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "mercuryProjectUrl"
                              },
                              {
                                "kind": "LinkedField",
                                "name": "mercuryProjectOwner",
                                "plural": false,
                                "selections": (v89/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "name": "externalOwner",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "firstName"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastName"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraAlignAggProject"
                          },
                          (v96/*: any*/)
                        ]
                      },
                      (v15/*: any*/)
                    ]
                  },
                  (v53/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canAddJiraAlignItems"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveJiraAlignItems"
                  }
                ]
              }
            ]
          },
          {
            "condition": "isJiraTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canAddLinkedWorkItems"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveLinkedWorkItems"
                  }
                ]
              },
              {
                "args": (v98/*: any*/),
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
                "kind": "LinkedField",
                "name": "workItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*: any*/),
                              (v29/*: any*/),
                              (v81/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "webUrl"
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          (v96/*: any*/)
                        ]
                      },
                      (v54/*: any*/),
                      (v15/*: any*/)
                    ]
                  },
                  (v55/*: any*/),
                  (v53/*: any*/)
                ]
              },
              {
                "args": (v98/*: any*/),
                "filters": [
                  "queryContext"
                ],
                "handle": "connection",
                "key": "GoalContentJira_workItems",
                "kind": "LinkedHandle",
                "name": "workItems"
              }
            ]
          },
          {
            "condition": "isLearningsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v29/*: any*/),
              (v64/*: any*/),
              (v77/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v99/*: any*/),
                            "type": "TownsquareLearning"
                          }
                        ]
                      }
                    ]
                  },
                  (v53/*: any*/)
                ]
              },
              (v100/*: any*/)
            ]
          },
          {
            "condition": "isRisksTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v29/*: any*/),
              (v64/*: any*/),
              (v77/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v99/*: any*/),
                            "type": "TownsquareRisk"
                          }
                        ]
                      }
                    ]
                  },
                  (v53/*: any*/)
                ]
              },
              (v100/*: any*/)
            ]
          },
          {
            "condition": "isDecisionsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v29/*: any*/),
              (v64/*: any*/),
              (v77/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v99/*: any*/),
                            "type": "TownsquareDecision"
                          }
                        ]
                      }
                    ]
                  },
                  (v53/*: any*/)
                ]
              },
              (v100/*: any*/)
            ]
          },
          {
            "condition": "isProjectsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveLinkedProjects"
                  },
                  {
                    "concreteType": "TownsquareGoalAppCapabilities",
                    "kind": "LinkedField",
                    "name": "apps",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/)
                    ]
                  },
                  (v101/*: any*/)
                ]
              },
              {
                "args": (v102/*: any*/),
                "concreteType": "TownsquareProjectConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v21/*: any*/),
                      (v54/*: any*/),
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v15/*: any*/),
                          (v103/*: any*/),
                          (v104/*: any*/),
                          (v106/*: any*/),
                          {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareProjectPhaseDetails",
                                "kind": "LinkedField",
                                "name": "newPhase",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "_id",
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              },
                              (v15/*: any*/)
                            ]
                          },
                          (v91/*: any*/),
                          (v30/*: any*/),
                          (v64/*: any*/),
                          (v107/*: any*/),
                          (v109/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v55/*: any*/),
                  (v53/*: any*/)
                ],
                "storageKey": "projects(first:200,tql:\"archived = false\")"
              },
              (v110/*: any*/),
              {
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v91/*: any*/),
                          (v30/*: any*/),
                          (v65/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalTypeIcon",
                                "kind": "LinkedField",
                                "name": "icon",
                                "plural": false,
                                "selections": [
                                  (v29/*: any*/)
                                ]
                              },
                              (v15/*: any*/)
                            ]
                          },
                          {
                            "args": (v102/*: any*/),
                            "concreteType": "TownsquareProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareProject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v91/*: any*/),
                                      (v30/*: any*/),
                                      (v64/*: any*/),
                                      (v107/*: any*/),
                                      (v103/*: any*/),
                                      (v109/*: any*/),
                                      (v104/*: any*/),
                                      (v21/*: any*/),
                                      (v106/*: any*/)
                                    ]
                                  },
                                  (v54/*: any*/),
                                  (v21/*: any*/)
                                ]
                              },
                              (v55/*: any*/),
                              (v53/*: any*/)
                            ],
                            "storageKey": "projects(first:200,tql:\"archived = false\")"
                          },
                          (v110/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              (v101/*: any*/)
                            ]
                          },
                          (v79/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v45/*: any*/),
                              (v70/*: any*/),
                              (v30/*: any*/),
                              (v15/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": (v108/*: any*/)
                          },
                          (v66/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v53/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bab7c1dad02a329512e40ea7df1c6e49083e199bbc28b2d6f75daf5c9ead996f",
    "metadata": {},
    "name": "AggGoalTabContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c4dc9d27c53bfd9ff82b7370552a17d0";

export default node;
